var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M118 38.733a3.386 3.386 0 0 0-.67-.066A3.343 3.343 0 0 0 113.977 42c0 1.84 1.501 3.333 3.353 3.333.23 0 .453-.023.67-.066v6.763c-3.759.337-6.705 3.478-6.705 7.303 0 .225.01.447.03.667H8.016c.02-.22.03-.442.03-.667C8.045 55.283 4.744 52 .67 52c-.226 0-.45.01-.67.03v-6.763c.217.043.44.066.67.066A3.343 3.343 0 0 0 4.023 42c0-1.84-1.501-3.333-3.353-3.333-.23 0-.453.023-.67.066v-5.466c.217.043.44.066.67.066A3.343 3.343 0 0 0 4.023 30c0-1.84-1.501-3.333-3.353-3.333-.23 0-.453.023-.67.066v-5.466c.217.043.44.066.67.066A3.343 3.343 0 0 0 4.023 18c0-1.84-1.501-3.333-3.353-3.333-.23 0-.453.023-.67.066V7.97c.22.02.444.03.67.03C4.744 8 8.045 4.717 8.045.667c0-.225-.01-.447-.03-.667h103.31c-.02.22-.03.442-.03.667 0 3.825 2.946 6.966 6.705 7.303v6.763a3.386 3.386 0 0 0-.67-.066A3.343 3.343 0 0 0 113.977 18c0 1.84 1.501 3.333 3.353 3.333.23 0 .453-.023.67-.066v5.466a3.386 3.386 0 0 0-.67-.066A3.343 3.343 0 0 0 113.977 30c0 1.84 1.501 3.333 3.353 3.333.23 0 .453-.023.67-.066v5.466z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 85,
    height: 34,
    x: 17,
    y: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 85,
    height: 34,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M118 38.733a3.386 3.386 0 0 0-.67-.066A3.343 3.343 0 0 0 113.977 42c0 1.84 1.501 3.333 3.353 3.333.23 0 .453-.023.67-.066v6.763c-3.759.337-6.705 3.478-6.705 7.303 0 .225.01.447.03.667H8.016c.02-.22.03-.442.03-.667C8.045 55.283 4.744 52 .67 52c-.226 0-.45.01-.67.03v-6.763c.217.043.44.066.67.066A3.343 3.343 0 0 0 4.023 42c0-1.84-1.501-3.333-3.353-3.333-.23 0-.453.023-.67.066v-5.466c.217.043.44.066.67.066A3.343 3.343 0 0 0 4.023 30c0-1.84-1.501-3.333-3.353-3.333-.23 0-.453.023-.67.066v-5.466c.217.043.44.066.67.066A3.343 3.343 0 0 0 4.023 18c0-1.84-1.501-3.333-3.353-3.333-.23 0-.453.023-.67.066V7.97c.22.02.444.03.67.03C4.744 8 8.045 4.717 8.045.667c0-.225-.01-.447-.03-.667h103.31c-.02.22-.03.442-.03.667 0 3.825 2.946 6.966 6.705 7.303v6.763a3.386 3.386 0 0 0-.67-.066A3.343 3.343 0 0 0 113.977 18c0 1.84 1.501 3.333 3.353 3.333.23 0 .453-.023.67-.066v5.466a3.386 3.386 0 0 0-.67-.066A3.343 3.343 0 0 0 113.977 30c0 1.84 1.501 3.333 3.353 3.333.23 0 .453-.023.67-.066v5.466z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 85,
    height: 34,
    x: 17,
    y: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 85,
    height: 34,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88 61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25 11.127 59.543)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M117.5 38.17v-4.34a3.93 3.93 0 0 1-.17.003c-2.127 0-3.853-1.715-3.853-3.833 0-2.118 1.726-3.833 3.853-3.833.057 0 .113 0 .17.003v-4.34a3.93 3.93 0 0 1-.17.003c-2.127 0-3.853-1.715-3.853-3.833 0-2.118 1.726-3.833 3.853-3.833.057 0 .113 0 .17.003V8.414c-3.816-.565-6.705-3.84-6.705-7.747l.002-.167H8.544l.001.167C8.545 4.994 5.02 8.5.67 8.5c-.056 0-.113 0-.17-.002v5.672a3.93 3.93 0 0 1 .17-.003c2.127 0 3.853 1.715 3.853 3.833 0 2.118-1.726 3.833-3.853 3.833a3.93 3.93 0 0 1-.17-.003v4.34a3.93 3.93 0 0 1 .17-.003c2.127 0 3.853 1.715 3.853 3.833 0 2.118-1.726 3.833-3.853 3.833a3.93 3.93 0 0 1-.17-.003v4.34a3.93 3.93 0 0 1 .17-.003c2.127 0 3.853 1.715 3.853 3.833 0 2.118-1.726 3.833-3.853 3.833a3.93 3.93 0 0 1-.17-.003v5.672l.17-.002c4.35 0 7.875 3.506 7.875 7.833l-.001.167h102.253a7.933 7.933 0 0 1-.002-.167c0-3.908 2.889-7.182 6.705-7.747V45.83a3.93 3.93 0 0 1-.17.003c-2.127 0-3.853-1.715-3.853-3.833 0-2.118 1.726-3.833 3.853-3.833.057 0 .113 0 .17.003z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 43,
    x: 12.568,
    y: 8.5,
    stroke: "#64808C",
    rx: 3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillOpacity: 0.423,
    stroke: "#64808C",
    strokeDasharray: "2,2,2,2",
    strokeWidth: 2,
    mask: "url(#e)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 65)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M117.5 38.17v-4.34a3.93 3.93 0 0 1-.17.003c-2.127 0-3.853-1.715-3.853-3.833 0-2.118 1.726-3.833 3.853-3.833.057 0 .113 0 .17.003v-4.34a3.93 3.93 0 0 1-.17.003c-2.127 0-3.853-1.715-3.853-3.833 0-2.118 1.726-3.833 3.853-3.833.057 0 .113 0 .17.003V8.414c-3.816-.565-6.705-3.84-6.705-7.747l.002-.167H8.544l.001.167C8.545 4.994 5.02 8.5.67 8.5c-.056 0-.113 0-.17-.002v5.672a3.93 3.93 0 0 1 .17-.003c2.127 0 3.853 1.715 3.853 3.833 0 2.118-1.726 3.833-3.853 3.833a3.93 3.93 0 0 1-.17-.003v4.34a3.93 3.93 0 0 1 .17-.003c2.127 0 3.853 1.715 3.853 3.833 0 2.118-1.726 3.833-3.853 3.833a3.93 3.93 0 0 1-.17-.003v4.34a3.93 3.93 0 0 1 .17-.003c2.127 0 3.853 1.715 3.853 3.833 0 2.118-1.726 3.833-3.853 3.833a3.93 3.93 0 0 1-.17-.003v5.672l.17-.002c4.35 0 7.875 3.506 7.875 7.833l-.001.167h102.253a7.933 7.933 0 0 1-.002-.167c0-3.908 2.889-7.182 6.705-7.747V45.83a3.93 3.93 0 0 1-.17.003c-2.127 0-3.853-1.715-3.853-3.833 0-2.118 1.726-3.833 3.853-3.833.057 0 .113 0 .17.003z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 44,
    x: 12.068,
    y: 8,
    fill: "#87D5FA",
    rx: 3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillOpacity: 0.423,
    stroke: "#64808C",
    strokeDasharray: "2,2,2,2",
    strokeWidth: 2,
    mask: "url(#g)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 111,
    r: 20,
    fill: "#EB8181"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 105v12M131 111h-12"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsEmpty);
export default __webpack_public_path__ + "static/media/coupons-empty.e062cae40d445136174fa83d1a56974b.svg";
export { ForwardRef as ReactComponent };